export const Badge = {
	name: 'Badge',
	functional: true,
	props: {
		text: String,
		color: String,
		background: String,
	},
	render(h, { props, data }) {
		return (
			<span
				class="badge"
				style={{
					color: props.color,
					backgroundColor: props.background,
				}}
				{ ...data }
			>
				{ props.text }
			</span>
		);
	}
}

/** @enum */
export const Themes = {
	Red: {
		color: '#c90404',
		background: '#fed2d2',
	},
	Blue: {
		color: '#002d75',
		background: '#b8d3ff',
	},
	Pink: {
		color: '#ff4eb5',
		background: '#ffecf7',
	},
	Grey: {
		color: '#2f2f34',
		background: '#ececee',
	},
}
